// NotificationsController
app.controller('NotificationsController', ['$scope', 'WdHttpService',
    function($scope, WdHttpService) {

        // Init 
        $scope.init = async function() {
            await $scope.fetchAdviserSiteDetails();
            $scope.notifyDate = [];
            $scope.notifyList = [];
            $scope.limit = 6;
            $scope.dataLoadMore = false;
            $scope.getNotifications();
        }

        var tenDaysAgo = new Date().getTime() - 10 * 24 * 60 * 60 * 1000;

        $scope.notificationRedirection = function(notificationTitle) {
            if (notificationTitle = 'Fund Rebalanced') {
                window.location.href = '/fund-revision';

            } else if (notificationTitle == 'Fund Subscription' || notificationTitle == 'Partial withdrawal' || notificationTitle == 'Fund LumpSum added') {
                window.location.href = '/user-fund/{{data.json_message.author}}/{{data.json_message.fund_name}}/{{data.json_message.investingMode}}';

            } else if (notificationTitle == 'Phone number updated' || notificationTitle == 'KYC Updated' || notificationTitle == 'KYC Approved' || notificationTitle == 'Fund Exited') {
                window.location.href = '/fund-discovery';

            } else if (notificationTitle == 'Open Advise Trade Executed' || notificationTitle == 'Close Advise Trade Executed' || notificationTitle == 'Open Advise Trade Rejected' || notificationTitle == 'Insufficient Capital') {
                window.location.href = '/my-portfolio';
            } else {
                window.location.href = '/fund-discovery';
            }
        }
        $scope.getNotifications = function() {
            $scope.showPageLoader();
            var data = { notificationTimestamp: tenDaysAgo };

            WdHttpService._notifications(data)
                .then(function(response) {
                    var notifyData = response.data.notifications;
                    angular.forEach(notifyData, function(value) {
                        var regDate = value.notification_timestamp;
                        var regNewDate = covertRegDate(new Date(+regDate));

                        function covertRegDate(date) {
                            var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                                'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
                            ];

                            return date.getUTCDate() + ' ' + months[date.getUTCMonth()] + ' ' + date.getUTCFullYear();
                        }
                        $scope.notifyDate[regDate] = regNewDate;
                        $scope.notifyList.push(value);
                        // angular.forEach(value.json_message, function (mValue, mKey) {
                        //     $scope.notifyDate = mValue;
                        // });
                    });
                    if (notifyData.length == 0) {
                        $scope.dataLoadMore = false;
                        $scope.noMoreData = true;
                    } else if (notifyData.length <= $scope.limit) {
                        $scope.dataLoadMore = false;
                    } else {
                        $scope.dataLoadMore = true;
                        $scope.noMoreData = false;
                    }
                    $scope.hidePageLoader();
                    $scope.$evalAsync();
                }).catch(error => {
                    $scope.noMoreData = true;
                    $scope.showErrorPopup(error);
                    $scope.hidePageLoader();
                });
        }

        $scope.loadMore = function() {
            $scope.limit = $scope.limit + 10;
            if ($scope.limit >= $scope.notifyList.length) {
                if ($scope.lastEvaluatedKey !== null) {
                    $scope.getNotifications();
                } else {
                    $scope.dataLoadMore = false;
                }
            }
        }

    }
]);